import React from 'react'
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';

const DatosPersonales = ({user}) => {

   const formatearFecha = (fecha) =>{
    const fechaconformato = fecha.split('-');

    let fechaprint = fechaconformato[2] + "-" + fechaconformato[1] + "-" + fechaconformato[0]
    return fechaprint
   }


  return (
    <>

        <Row style={{marginBottom:'30px'}}>
            <Col>     
                <Card>
                    <Card.Header>Datos del responsable del proyecto</Card.Header>
                    <Card.Body>
                        <ListGroup variant="flush" style={{lineHeight:'30px'}}>   
                            <ListGroup.Item > 
                                <strong>Nombre y apellido: </strong> {user.name_user}<br/>
                                <strong>Correo electrónico: </strong> {user.email_user}<br/>
                                <strong>DNI: </strong> {user.dni}<br/>
                                <strong>Telefono: </strong> {user.telefono}<br/>
                                <strong>Fecha de nacimiento: </strong> {formatearFecha(user.fecha_nac)}<br/>
                            </ListGroup.Item>
                        </ListGroup>                           
                    </Card.Body>
                </Card>                         
            </Col>
        </Row>    

    </>
  )
}

export default DatosPersonales



